export const DASHBOARD_LOAD = 'DASHBOARD_LOAD';
export const DASHBOARD_LOAD_SUCCESS = 'DASHBOARD_LOAD_SUCCESS';
export const DASHBOARD_LOAD_ERROR = 'DASHBOARD_LOAD_ERROR';


export const IMPORTANT_DOCUMENTS_LOAD = 'IMPORTANT_DOCUMENTS_LOAD';
export const IMPORTANT_DOCUMENTS_LOAD_SUCCESS = 'IMPORTANT_DOCUMENTS_LOAD_SUCCESS';
export const IMPORTANT_DOCUMENTS_LOAD_ERROR = 'IMPORTANT_DOCUMENTS_LOAD_ERROR';


export const LIFE_AT_INNOGY_LOAD = 'LIFE_AT_INNOGY_LOAD';
export const LIFE_AT_INNOGY_LOAD_SUCCESS = 'LIFE_AT_INNOGY_LOAD_SUCCESS';
export const LIFE_AT_INNOGY_LOAD_ERROR = 'LIFE_AT_INNOGY_LOAD_ERROR';


export const ASSIGNMENT_ACTION = 'ASSIGNMENT_ACTION';
export const ASSIGNMENT_ACTION_SUCCESS = 'ASSIGNMENT_ACTION_SUCCESS';
export const ASSIGNMENT_ACTION_ERROR = 'ASSIGNMENT_ACTION_ERROR';

export const ASSIGNMENT_SELECT = 'ASSIGNMENT_SELECT';
export const ASSIGNMENT_SELECT_SUCCESS = 'ASSIGNMENT_SELECT_SUCCESS';
export const ASSIGNMENT_SELECT_ERROR = 'ASSIGNMENT_SELECT_ERROR';

export const ACCOUNT_ACTIVATION = 'ACCOUNT_ACTIVATION';
export const ACCOUNT_ACTIVATION_SUCCESS = 'ACCOUNT_ACTIVATION_SUCCESS';
export const ACCOUNT_ACTIVATION_ERROR = 'ACCOUNT_ACTIVATION_ERROR';

export const CONSTANTS_LOAD = 'CONSTANTS_LOAD';
export const CONSTANTS_LOAD_SUCCESS = 'CONSTANTS_LOAD_SUCCESS';
export const CONSTANTS_LOAD_ERROR = 'CONSTANTS_LOAD_ERROR';

export const LANGUAGE_SET = 'LANGUAGE_SET';
export const LANGUAGE_SET_SUCCESS = 'LANGUAGE_SET_SUCCESS';
export const LANGUAGE_SET_ERROR = 'LANGUAGE_SET_ERROR';
